import React from 'react';
import { CenteredLink, SearchTriangle } from './styles';
import { RemixRoutes } from '~/core/remix';
export type Link = {
  url: string;
  label: string;
  richLabel?: React.ReactNode;
  mobileOnly?: boolean;
};

export type Subcategory = { label: string; links: Link[] };

export type NavItem = Link | Subcategory;

export type NavItems = NavItem[];

export const isLink = (navItem: NavItem): navItem is Link => {
  return (navItem as Link).url !== undefined;
};

export const isSubcategory = (navItem: NavItem): navItem is Subcategory => {
  return (navItem as Subcategory).links !== undefined;
};

export const womensHealthNavItems: NavItems = [
  {
    label: 'Urinary tract infection',
    url: 'https://www.solvhealth.com/r/search?serviceIds=p8rWQ9&query=Urinary+tract+infection',
  },
  {
    label: 'Pap smear',
    url: 'https://www.solvhealth.com/r/search?serviceIds=gmY4vg&query=Pap+Smear',
  },
  {
    label: 'Pregnancy test',
    url: 'https://www.solvhealth.com/r/search?serviceIds=RpRnpV&query=Pregnancy+test',
  },
];

export const popularTestNavItems: NavItems = [
  {
    label: 'Allergy testing',
    url: 'https://www.solvhealth.com/r/search?serviceIds=MgYZdp&query=Allergy+testing',
  },
  {
    label: 'COVID testing',
    url: 'https://www.solvhealth.com/r/search?serviceIds=p3MME9&query=COVID+testing',
  },
  {
    label: 'Diabetes testing',
    url: 'https://www.solvhealth.com/r/search?serviceIds=pEZVyO&query=Diabetes+testing',
  },
  {
    label: 'Drug testing',
    url: 'https://www.solvhealth.com/r/search?serviceIds=K9qlOz&query=Drug+testing',
  },
  {
    label: 'STD testing',
    url: 'https://www.solvhealth.com/r/search?serviceIds=4pzBpq&query=STD+testing',
  },
  {
    label: 'Strep test',
    url: 'https://www.solvhealth.com/r/search?serviceIds=LOQ0p1&query=Strep+testing',
  },
];

export const everydayHealthNavItems: NavItems = [
  {
    label: 'Mental health',
    url: RemixRoutes.mentalHealth,
  },
  {
    label: 'Prescription discounts',
    url: 'https://www.solvhealth.com/prescription-discount',
  },
  {
    label: 'Tdap vaccine',
    links: [
      {
        label: 'Atlanta, GA',
        url: 'https://www.solvhealth.com/ga/c/atlanta-ga-srv-tetanus-vaccine',
      },
      {
        label: 'Boston, MA',
        url: 'https://www.solvhealth.com/ma/c/boston-ma-srv-tetanus-vaccine',
      },
      {
        label: 'Charleston, WV',
        url: 'https://www.solvhealth.com/wv/c/charleston-wv-srv-tetanus-vaccine',
      },
      {
        label: 'Chicago, IL',
        url: 'https://www.solvhealth.com/il/c/chicago-il-srv-tetanus-vaccine',
      },
      {
        label: 'Dallas, TX',
        url: 'https://www.solvhealth.com/tx/c/dallas-tx-srv-tetanus-vaccine',
      },
      {
        label: 'Denver, CO',
        url: 'https://www.solvhealth.com/co/c/denver-co-srv-tetanus-vaccine',
      },
      {
        label: 'Houston, TX',
        url: 'https://www.solvhealth.com/tx/c/houston-tx-srv-tetanus-vaccine',
      },
      {
        label: 'Los Angeles, CA',
        url: 'https://www.solvhealth.com/ca/c/los-angeles-ca-srv-tetanus-vaccine',
      },
      {
        label: 'Nashville, TN',
        url: 'https://www.solvhealth.com/tn/c/nashville-tn-srv-tetanus-vaccine',
      },
      {
        label: 'New York, NY',
        url: 'https://www.solvhealth.com/ny/c/new-york-ny-srv-tetanus-vaccine',
      },
      {
        label: 'Ontario, CA',
        url: 'https://www.solvhealth.com/ca/c/ontario-ca-srv-tetanus-vaccine',
      },
      {
        label: 'San Francisco, CA',
        url: 'https://www.solvhealth.com/ca/c/san-francisco-ca-srv-tetanus-vaccine',
      },
      {
        label: 'Seattle, WA',
        url: 'https://www.solvhealth.com/wa/c/seattle-wa-srv-tetanus-vaccine',
      },
      {
        label: 'Tulsa, OK',
        url: 'https://www.solvhealth.com/ok/c/tulsa-ok-srv-tetanus-vaccine',
      },
      {
        label: 'Washington DC',
        url: 'https://www.solvhealth.com/dc/c/washington-dc-srv-tetanus-vaccine',
      },
    ],
  },
  {
    label: 'DOT physical',
    links: [
      {
        label: 'Albuquerque, NM',
        url: 'https://www.solvhealth.com/nm/c/albuquerque-nm-srv-dot-physicals',
      },
      {
        label: 'Chicago, IL',
        url: 'https://www.solvhealth.com/il/c/chicago-il-srv-dot-physicals',
      },
      {
        label: 'Cleveland, OH',
        url: 'https://www.solvhealth.com/oh/c/cleveland-oh-srv-dot-physicals',
      },
      {
        label: 'Dallas, TX',
        url: 'https://www.solvhealth.com/tx/c/dallas-tx-srv-dot-physicals',
      },
      {
        label: 'Denver, CO',
        url: 'https://www.solvhealth.com/co/c/denver-co-srv-dot-physicals',
      },
      {
        label: 'Detroit, MI',
        url: 'https://www.solvhealth.com/mi/c/detroit-mi-srv-dot-physicals',
      },
      {
        label: 'Fort Worth, TX',
        url: 'https://www.solvhealth.com/tx/c/fort-worth-tx-srv-dot-physicals',
      },
      {
        label: 'Memphis, TN',
        url: 'https://www.solvhealth.com/tn/c/memphis-tn-srv-dot-physicals',
      },
      {
        label: 'Nashville, TN',
        url: 'https://www.solvhealth.com/tn/c/nashville-tn-srv-dot-physicals',
      },
      {
        label: 'New York, NY',
        url: 'https://www.solvhealth.com/ny/c/new-york-ny-srv-dot-physicals',
      },
      {
        label: 'Oklahoma City, OK',
        url: 'https://www.solvhealth.com/ok/c/oklahoma-city-ok-srv-dot-physicals',
      },
      {
        label: 'Philadelphia, PA',
        url: 'https://www.solvhealth.com/pa/c/philadelphia-pa-srv-dot-physicals',
      },
      {
        label: 'Phoenix, AZ',
        url: 'https://www.solvhealth.com/az/c/phoenix-az-srv-dot-physicals',
      },
      {
        label: 'San Antonio, TX',
        url: 'https://www.solvhealth.com/tx/c/san-antonio-tx-srv-dot-physicals',
      },
      {
        label: 'San Francisco, CA',
        url: 'https://www.solvhealth.com/ca/c/san-francisco-ca-srv-dot-physicals',
      },
    ],
  },

  {
    label: 'School physicals',
    links: [
      {
        label: 'Albuquerque, NM',
        url: 'https://www.solvhealth.com/nm/c/albuquerque-nm-srv-sports-physicals',
      },
      {
        label: 'Chicago, IL',
        url: 'https://www.solvhealth.com/il/c/chicago-il-srv-sports-physicals',
      },
      {
        label: 'Cleveland, OH',
        url: 'https://www.solvhealth.com/oh/c/cleveland-oh-srv-sports-physicals',
      },
      {
        label: 'Dallas, TX',
        url: 'https://www.solvhealth.com/tx/c/dallas-tx-srv-sports-physicals',
      },
      {
        label: 'Denver, CO',
        url: 'https://www.solvhealth.com/co/c/denver-co-srv-sports-physicals',
      },
      {
        label: 'Detroit, MI',
        url: 'https://www.solvhealth.com/mi/c/detroit-mi-srv-sports-physicals',
      },
      {
        label: 'Fort Worth, TX',
        url: 'https://www.solvhealth.com/tx/c/fort-worth-tx-srv-sports-physicals',
      },
      {
        label: 'Memphis, TN',
        url: 'https://www.solvhealth.com/tn/c/memphis-tn-srv-sports-physicals',
      },
      {
        label: 'Nashville, TN',
        url: 'https://www.solvhealth.com/tn/c/nashville-tn-srv-sports-physicals',
      },
      {
        label: 'New York, NY',
        url: 'https://www.solvhealth.com/ny/c/new-york-ny-srv-sports-physicals',
      },
      {
        label: 'Oklahoma City, OK',
        url: 'https://www.solvhealth.com/ok/c/oklahoma-city-ok-srv-sports-physicals',
      },
      {
        label: 'Philadelphia, PA',
        url: 'https://www.solvhealth.com/pa/c/philadelphia-pa-srv-sports-physicals',
      },
      {
        label: 'Phoenix, AZ',
        url: 'https://www.solvhealth.com/az/c/phoenix-az-srv-sports-physicals',
      },
      {
        label: 'San Antonio, TX',
        url: 'https://www.solvhealth.com/tx/c/san-antonio-tx-srv-sports-physicals',
      },
      {
        label: 'San Francisco, CA',
        url: 'https://www.solvhealth.com/ca/c/san-francisco-ca-srv-sports-physicals',
      },
    ],
  },

  {
    label: 'Ear wax cleaning',
    links: [
      {
        label: 'Boston, MA',
        url: 'https://www.solvhealth.com/ma/c/boston-ma-srv-ear-wax-removal',
      },
      {
        label: 'Chicago, IL',
        url: 'https://www.solvhealth.com/il/c/chicago-il-srv-ear-wax-removal',
      },
      {
        label: 'Dallas, TX',
        url: 'https://www.solvhealth.com/tx/c/dallas-tx-srv-ear-wax-removal',
      },
      {
        label: 'Houston, TX',
        url: 'https://www.solvhealth.com/tx/c/houston-tx-srv-ear-wax-removal',
      },
      {
        label: 'Jacksonville, FL',
        url: 'https://www.solvhealth.com/fl/c/jacksonville-fl-srv-ear-wax-removal',
      },
      {
        label: 'Los Angeles, CA',
        url: 'https://www.solvhealth.com/ca/c/los-angeles-ca-srv-ear-wax-removal',
      },
      {
        label: 'New York, NY',
        url: 'https://www.solvhealth.com/ny/c/new-york-ny-srv-ear-wax-removal',
      },
      {
        label: 'Oklahoma City, OK',
        url: 'https://www.solvhealth.com/ok/c/oklahoma-city-ok-srv-ear-wax-removal',
      },
      {
        label: 'Philadelphia, PA',
        url: 'https://www.solvhealth.com/pa/c/philadelphia-pa-srv-ear-wax-removal',
      },
      {
        label: 'Phoenix, AZ',
        url: 'https://www.solvhealth.com/az/c/phoenix-az-srv-ear-wax-removal',
      },
      {
        label: 'San Antonio, TX',
        url: 'https://www.solvhealth.com/tx/c/san-antonio-tx-srv-ear-wax-removal',
      },
      {
        label: 'San Francisco, CA',
        url: 'https://www.solvhealth.com/ca/c/san-francisco-ca-srv-ear-wax-removal',
      },
      {
        label: 'Seattle, WA',
        url: 'https://www.solvhealth.com/wa/c/seattle-wa-srv-ear-wax-removal',
      },
      {
        label: 'Tucson, AZ',
        url: 'https://www.solvhealth.com/az/c/tucson-az-srv-ear-wax-removal',
      },
    ],
  },
];

export const urgentCareNavItems: NavItems = [
  {
    label: 'Urgent care',
    links: [
      {
        label: 'Urgent care near me',
        richLabel: (
          <CenteredLink>
            <SearchTriangle src="/images/icons/location_triangle.svg" /> Urgent care near me
          </CenteredLink>
        ),
        mobileOnly: true,
        url: 'https://www.solvhealth.com/r/search?query=Urgent+care&modality=urgent_care',
      },
      {
        label: 'Atlanta, GA',
        url: 'https://www.solvhealth.com/ga/c/atlanta-ga-urgent-care',
      },
      {
        label: 'Boston, MA',
        url: 'https://www.solvhealth.com/ma/c/boston-ma-urgent-care',
      },
      {
        label: 'Charlotte, NC',
        url: 'https://www.solvhealth.com/nc/c/charlotte-nc-urgent-care',
      },
      {
        label: 'Chicago, IL',
        url: 'https://www.solvhealth.com/il/c/chicago-il-urgent-care',
      },
      {
        label: 'Dallas, TX',
        url: 'https://www.solvhealth.com/tx/c/dallas-tx-urgent-care',
      },
      {
        label: 'Detroit, MI',
        url: 'https://www.solvhealth.com/mi/c/detroit-mi-urgent-care',
      },
      {
        label: 'Houston, TX',
        url: 'https://www.solvhealth.com/tx/c/houston-tx-urgent-care',
      },
      {
        label: 'Los Angeles, CA',
        url: 'https://www.solvhealth.com/ca/c/los-angeles-ca-urgent-care',
      },
      {
        label: 'Nashville, TN',
        url: 'https://www.solvhealth.com/tn/c/nashville-tn-urgent-care',
      },
      {
        label: 'New York, NY',
        url: 'https://www.solvhealth.com/ny/c/new-york-ny-urgent-care',
      },
      {
        label: 'Philadelphia, PA',
        url: 'https://www.solvhealth.com/pa/c/philadelphia-pa-urgent-care',
      },
      {
        label: 'Phoenix, AZ',
        url: 'https://www.solvhealth.com/az/c/phoenix-az-urgent-care',
      },
      {
        label: 'San Antonio, TX',
        url: 'https://www.solvhealth.com/tx/c/san-antonio-tx-urgent-care',
      },
      {
        label: 'San Francisco, CA',
        url: 'https://www.solvhealth.com/ca/c/san-francisco-ca-urgent-care',
      },
      {
        label: 'Seattle, WA',
        url: 'https://www.solvhealth.com/wa/c/seattle-wa-urgent-care',
      },
      {
        label: 'Tucson, AZ',
        url: '/az/c/tucson-az-urgent-care',
      },
    ],
  },
  {
    label: 'Pediatric urgent care',
    links: [
      {
        label: 'Pediatric urgent care near me',
        richLabel: (
          <CenteredLink>
            <SearchTriangle src="/images/icons/location_triangle.svg" /> Pediatric urgent care near
            me
          </CenteredLink>
        ),
        mobileOnly: true,
        url: 'https://www.solvhealth.com/r/search?query=Pediatric+urgent+care&patient=child',
      },
      {
        label: 'Atlanta, GA',
        url: 'https://www.solvhealth.com/ga/c/atlanta-ga-pediatric-urgent-care',
      },
      {
        label: 'Baltimore, MD',
        url: 'https://www.solvhealth.com/md/c/baltimore-md-pediatric-urgent-care',
      },
      {
        label: 'Boston, MA',
        url: 'https://www.solvhealth.com/ma/c/boston-ma-pediatric-urgent-care',
      },
      {
        label: 'Chicago, IL',
        url: 'https://www.solvhealth.com/il/c/chicago-il-pediatric-urgent-care',
      },
      {
        label: 'Dallas, TX',
        url: 'https://www.solvhealth.com/tx/c/dallas-tx-pediatric-urgent-care',
      },
      {
        label: 'Houston, TX',
        url: 'https://www.solvhealth.com/tx/c/houston-tx-pediatric-urgent-care',
      },
      {
        label: 'Los Angeles, CA',
        url: 'https://www.solvhealth.com/ca/c/los-angeles-ca-pediatric-urgent-care',
      },
      {
        label: 'Nashville, TN',
        url: 'https://www.solvhealth.com/tn/c/nashville-tn-pediatric-urgent-care',
      },
      {
        label: 'New York, NY',
        url: 'https://www.solvhealth.com/ny/c/new-york-ny-pediatric-urgent-care',
      },
      {
        label: 'Philadelphia, PA',
        url: 'https://www.solvhealth.com/pa/c/philadelphia-pa-pediatric-urgent-care',
      },
      {
        label: 'Phoenix, AZ',
        url: 'https://www.solvhealth.com/az/c/phoenix-az-pediatric-urgent-care',
      },
      {
        label: 'San Antonio, TX',
        url: 'https://www.solvhealth.com/tx/c/san-antonio-tx-pediatric-urgent-care',
      },
      {
        label: 'San Francisco, CA',
        url: 'https://www.solvhealth.com/ca/c/san-francisco-ca-pediatric-urgent-care',
      },
      {
        label: 'Seattle, WA',
        url: 'https://www.solvhealth.com/wa/c/seattle-wa-pediatric-urgent-care',
      },
      {
        label: 'Washington DC',
        url: 'https://www.solvhealth.com/dc/c/washington-dc-pediatric-urgent-care',
      },
    ],
  },
  {
    label: 'Telemedicine',
    links: [
      {
        label: 'Telemedicine near me',
        richLabel: (
          <CenteredLink>
            <SearchTriangle src="/images/icons/location_triangle.svg" /> Telemedicine near me
          </CenteredLink>
        ),
        mobileOnly: true,
        url: 'https://www.solvhealth.com/r/search?query=Telemedicine&modality=telemed',
      },

      {
        label: 'Alabama',
        url: 'https://www.solvhealth.com/al/s/alabama-telemedicine',
      },
      {
        label: 'Arizona',
        url: 'https://www.solvhealth.com/az/s/arizona-telemedicine',
      },
      {
        label: 'California',
        url: 'https://www.solvhealth.com/ca/s/california-telemedicine',
      },
      {
        label: 'Connecticut',
        url: 'https://www.solvhealth.com/ct/s/connecticut-telemedicine',
      },
      {
        label: 'Florida',
        url: 'https://www.solvhealth.com/fl/s/florida-telemedicine',
      },
      {
        label: 'Georgia',
        url: 'https://www.solvhealth.com/ga/s/georgia-telemedicine',
      },
      {
        label: 'Illinois',
        url: 'https://www.solvhealth.com/il/s/illinois-telemedicine',
      },
      {
        label: 'Maine',
        url: 'https://www.solvhealth.com/me/s/maine-telemedicine',
      },
      {
        label: 'Nebraska',
        url: 'https://www.solvhealth.com/ne/s/nebraska-telemedicine',
      },
      {
        label: 'New Jersey',
        url: 'https://www.solvhealth.com/nj/s/new-jersey-telemedicine',
      },
      {
        label: 'New York',
        url: 'https://www.solvhealth.com/ny/s/new-york-telemedicine',
      },
      {
        label: 'Oklahoma',
        url: 'https://www.solvhealth.com/ok/s/oklahoma-telemedicine',
      },
      {
        label: 'Tennessee',
        url: 'https://www.solvhealth.com/tn/s/tennessee-telemedicine',
      },
      {
        label: 'Texas',
        url: 'https://www.solvhealth.com/tx/s/texas-telemedicine',
      },
      {
        label: 'Washington',
        url: 'https://www.solvhealth.com/wa/s/washington-telemedicine',
      },
      {
        label: 'Washington DC',
        url: 'https://www.solvhealth.com/dc/s/washington-dc-telemedicine',
      },
    ],
  },
];

export const mobileMenuLinks = [
  { label: 'Urgent care', url: '/for-providers/urgent-cares' },
  { label: 'Health systems', url: '/for-providers/health-systems' },
  { label: 'Why Solv', url: '/for-providers/why-solv' },
  { label: 'Pricing', url: '/for-providers/pricing' },
  { label: 'Provider log in', url: '/for-providers/login' },
  { label: 'Get a demo', url: '/for-providers/demo/request-demo' },
];
